export const SHARE_MODAL_UPSELL_MESSAGE =
  'Upgrade to unlock link settings like comments, custom fields, and security settings.';

export const INTELLIGENCE_UPSELL_MESSAGE = 'Upgrade to unlock full AI summaries and smart tags.';

export const INTELLIGENCE_STORAGE_LIMIT_MESSAGE =
  "You've reached your 10GB limit. Upgrade to unlock full AI summaries and tags.";
